import { createAction } from '@reduxjs/toolkit';

export const clearPatchCoOrders = createAction('clearPatchCoOrders');
export const clearDeleteCoOrders = createAction('clearDeleteCoOrders');
export const setCoOrders = createAction('setCoOrders');
export const removeCoOrder = createAction('removeCoOrder');
